import React from "react";
import {
  Container,
  Typography,
  Grid,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import spacecastVideo from "./spacecast.mp4";

export default function About() {
  return (
    <Container>
      <Box mt={5} mb={4}>
        <Typography variant="h4">FAQs about SPACECASTING</Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">How Does it Work?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                <Typography paragraph>
                  The Terasem Movement Foundation operates its own Earth station
                  transmitter to allow Spacecasting of your “bemes” (if you
                  choose that option) to Outer Space continuing into deep space
                  at the speed of light.
                </Typography>
                <Typography paragraph>
                  **Note you must choose this option from the “Personal Stats”
                  tab and can disable it at any time. You can elect to Spacecast
                  your mindfile data in terms of formats e.g. Video, Audio.
                </Typography>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">What is the Purpose?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Spacecasting your bemes ensures that some aspect of you can
                survive any catastrophe that might befall Earth. Advanced
                technology that is capable of recovering the Spacecast signal
                will also be capable of reconstructing yourself from the
                information in the Spacecast.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">
                Who Would be Reconstructing Me from My Spacecast?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                <Typography paragraph>
                  It is possible that you might be reconstructed by ETs. It is
                  also possible that future technology will enable people from
                  Earth to travel faster than light and catch your bemes. With
                  technology known today your bemes would have too little energy
                  density to recover at even solar system distances from the
                  Earth. However, future technology could employ humungous
                  synthetic aperture antenna arrays that could recover even the
                  faintest signals from Earth.
                </Typography>
                <Typography paragraph>
                  By comparison, please remember that even ten years ago our
                  telescopes were too weak to detect the minor gravitational
                  perturbations that reveal the presence of planets around other
                  stars. However, today, hundreds of such planets have been
                  detected.
                </Typography>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">
                Why Would I Want to be Reconstructed by an ET?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Terasemers believe that if the galaxy is populated with
                technologically advanced societies, then it is populated by
                friendly, ethical beings. We believe if the galaxy was populated
                by unfriendly technological advanced civilizations then Earth
                would have already been colonized by them. With self-replicating
                technology it takes a very brief period of time to visit every
                star in the galaxy. Consequently, if we are reconstructed by
                ETs, Terasem believes they would reconstruct us from our bemes
                consistently with how we would want to live.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Grid>

        <Grid item xs={12} sm={6}>
          <video controls={true} width="100%">
            <source src={spacecastVideo} type="video/mp4" />
            Sorry, this embedded video is not working.
          </video>
        </Grid>
      </Grid>
    </Container>
  );
}
